<template>
  <div
    v-if="!authStore.user?.attributes.activated"
    class="rounded-md bg-yellow-50 p-4"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <LDIcon
          icon="ExclamationIcon"
          class="h-5 w-5 text-yellow-400"
          aria-hidden="true"
        />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-yellow-800">
          This User is Currently disabled
        </h3>
        <div class="mt-2 text-sm text-yellow-700">
          <p>
            <span class="text-yellow-800">{{
              authStore.user?.attributes.additionalAttributes.lockedMessage
            }}</span>
          </p>
        </div>
        <div class="mt-2 text-sm text-yellow-700">
          <p>Please manage your user licenses and reactivate this user</p>
        </div>
      </div>
    </div>
  </div>
  <div
    v-for="(alert, idx) in alerts"
    :key="idx"
    class="rounded-md bg-yellow-50 p-4 mt-2"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <LDIcon
          icon="ExclamationIcon"
          class="h-5 w-5 text-yellow-400"
          aria-hidden="true"
        />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-yellow-800">
          {{ alert.title }}
        </h3>
        <div class="mt-2 text-sm text-yellow-700">
          <p>
            {{ alert.message }}
          </p>
        </div>
        <div
          v-if="alert.routeName"
          class="mt-2 text-sm text-yellow-700"
        >
          <RouterLink
            :to="{ name: alert.routeName }"
            class="text-yellow-900 font-semibold underline"
          >
            Resolve this issue
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { Ref, onMounted, ref } from 'vue'
  import LDIcon from './LDIcon.vue'
  import useLetsDialAPI from '/@/services/letsDialAPI/useLetsDialAPI'
  import { useAuthStore } from '/@/store/authStore'
  import { Alert } from '@letsdial/api/src'
  const authStore = useAuthStore()
  const api = useLetsDialAPI()
  const alerts: Ref<Alert[]> = ref([])

  const loadAlerts = async () => {
    if (authStore.selectedOrganization?.id) {
      const alertResult = await api.organizations.alerts(authStore.selectedOrganization.id)
      alerts.value = alertResult.attributes.alerts
    }
  }

  onMounted(() => {
    loadAlerts()
    setInterval(loadAlerts, 60000)
  })
</script>
